/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Control } from '../models/Control';
import { Pagination } from '../models/Pagination';

export class ListControlsResponse {
  'controls': Array<Control>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "controls",
      "baseName": "controls",
      "type": "Array<Control>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListControlsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

